export const scaleWidth = (Vue) => {
  /**
   * 等比例宽高自定义计算的指令
   * 
   * <p>
   *  根据绑定的DOM的宽度和传入的宽高比例值，自动计算DOM元素的高度。
   *  如果外部没有传入宽高比例时，宽高比会默认为16/9，传入参数的实例如： v-scale-width={ widthRatio: 16, heightRatio: 9 }
   * 
   *  注意：新的浏览器都支持aspect-ratio css 属性，用于设置元素固定的宽高比例。 但是很多老的浏览器如UC、QQ等尚不支持，所以需要用此指令实现。
   *  如果确保应用只会在固定且支持aspect-ratio css 属性版本的浏览器上使用，可以不用此指令。
   * </p>
   */
  Vue.directive('scaleWidth', {
    // DOM元素绑定指令时触发，只触发一次。内部无法获取到DOM元素真实的宽度
    bind: (el, binding) => {
      // console.log('directive bind , el width is :', el.offsetWidth)
    },
    // 被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。可以获取到DOm元素的宽度，所以宽高的计算放在此处进行
    inserted: (el, binding) =>{
      /**
       * 内置计算函数，用于计算元素实际上应该拥有的高度
       */
      function scale(){
        var width = el.scrollWidth
        // 宽度比例，默认为16
        // console.log(binding.value.widthRatio)
        var widthRatio = binding && binding.value && binding.value.widthRatio ? binding.value.widthRatio : 16 
        // 高度比例，默认为9
        // console.log(binding.value.heightRatio)
        var heightRatio =  binding && binding.value && binding.value.heightRatio ? binding.value.heightRatio : 9 
        // 根据宽度以及传入的宽高比得到元素应有的高度
        var height = width / widthRatio * heightRatio
        // 计算高度
        el.style.height = height + 'px'
      }
      // 触发此钩子事件后，默认执行scale内置函数，去执行宽度高度计算
      scale()
      // 添加window的resize监听，当页面宽度发生更改时，重新去执行sacle()函数
      window.addEventListener('resize', () => {
        scale()
      })
    }
  });

  
}